if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        this._mediaFilteringInitialized = false;

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
            
            setTimeout(() => {
              this.initMediaFiltering();
            }, 200);
            
            setTimeout(() => {
              this.initThumbnailActiveSync();
            }, 300);
            
            setTimeout(() => {
              this.replaceSliderCounterWithDots();
            }, 100);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
        this.forceMobileSliderLayout(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      forceMobileSliderLayout(productElement) {
        const mediaList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (mediaList) {
          mediaList.classList.remove('grid');
          mediaList.classList.add('slider', 'slider--mobile');
          const mediaItems = mediaList.querySelectorAll('.product__media-item');
          mediaItems.forEach((item) => {
            item.style.display = 'block';
          });
        }

        const thumbnailSlider = productElement.querySelector('[id^="GalleryThumbnails"]');
        if (thumbnailSlider) {
          thumbnailSlider.classList.remove('quick-add-hidden');
          thumbnailSlider.classList.remove('medium-hide', 'large-up-hide', 'small-hide');
          thumbnailSlider.style.display = 'block';
          
          const thumbnailList = thumbnailSlider.querySelector('.thumbnail-list');
          if (thumbnailList) {
            thumbnailList.classList.remove('medium-hide', 'large-up-hide');
            thumbnailList.classList.add('slider--tablet-up', 'slider--mobile');
            thumbnailList.style.display = 'flex';
          }

          const thumbnailButtons = thumbnailSlider.querySelectorAll('.slider-button');
          thumbnailButtons.forEach((button) => {
            button.classList.remove('medium-hide', 'large-up-hide', 'small-hide', 'hide');
            button.style.display = 'flex';
          });
        }

        const galleryViewer = productElement.querySelector('[id^="GalleryViewer"]');
        if (galleryViewer) {
          const sliderButtons = galleryViewer.querySelector('.slider-buttons');
          if (sliderButtons) {
            sliderButtons.classList.remove('quick-add-hidden', 'small-hide');
          }
        }

        const mediaGallery = productElement.querySelector('media-gallery');
        if (mediaGallery) {
          mediaGallery.setAttribute('data-desktop-layout', 'thumbnail_slider');
        }
      }

      replaceSliderCounterWithDots() {
        const modalContent = this.modalContent;
        const galleryViewer = modalContent.querySelector('[id^="GalleryViewer"]');
        if (!galleryViewer) return;

        const sliderButtons = galleryViewer.querySelector('.slider-buttons');
        if (!sliderButtons) return;

        const sliderCounter = sliderButtons.querySelector('.slider-counter');
        if (!sliderCounter) return;

        const mediaList = galleryViewer.querySelector('[id^="Slider-Gallery"]');
        if (!mediaList) return;

        const mediaItems = mediaList.querySelectorAll('.product__media-item');
        const mediaCount = mediaItems.length;

        if (mediaCount <= 1) {
          sliderCounter.style.display = 'none';
          return;
        }

        const dotsWrapper = document.createElement('div');
        dotsWrapper.className = 'slider-counter slider-counter--dots';

        const dotsContainer = document.createElement('div');
        dotsContainer.className = 'slideshow__control-wrapper';
        dotsContainer.setAttribute('role', 'tablist');
        dotsContainer.setAttribute('aria-label', 'Slider pagination');

        const dotLabels = ['First', 'Middle', 'Last'];
        const dotTargets = [
          0,
          Math.floor(mediaCount / 2),
          mediaCount - 1
        ];

        if (mediaCount === 2) {
          dotTargets[1] = 1;
        } else if (mediaCount > 2) {
          dotTargets[1] = Math.floor((1 + (mediaCount - 2)) / 2);
        }

        for (let i = 0; i < 3; i++) {
          const dotButton = document.createElement('button');
          dotButton.type = 'button';
          dotButton.className = `slider-counter__link slider-counter__link--dots link${i === 0 ? ' slider-counter__link--active' : ''}`;
          dotButton.setAttribute('role', 'tab');
          dotButton.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          dotButton.setAttribute('aria-label', `Go to ${dotLabels[i]} image`);
          dotButton.setAttribute('data-target-index', dotTargets[i]);
          
          const dot = document.createElement('span');
          dot.className = 'dot';
          dotButton.appendChild(dot);
          
          dotsContainer.appendChild(dotButton);
        }

        dotsWrapper.appendChild(dotsContainer);
        sliderCounter.replaceWith(dotsWrapper);

        const dots = dotsWrapper.querySelectorAll('.slider-counter__link');
        dots.forEach((dot, index) => {
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const targetIndex = parseInt(dot.getAttribute('data-target-index'));
            this.navigateToMedia(targetIndex, mediaList, dots);
          });
        });

        const self = this;
        
        const getActiveMediaIndex = () => {
          const activeMedia = mediaList.querySelector('.product__media-item.is-active');
          if (activeMedia) {
            return Array.from(mediaItems).indexOf(activeMedia);
          }
          
          const mediaArray = Array.from(mediaItems);
          const containerRect = mediaList.getBoundingClientRect();
          const containerCenter = containerRect.left + containerRect.width / 2;
          
          let closestIndex = 0;
          let closestDistance = Infinity;
          
          mediaArray.forEach((item, index) => {
            const itemRect = item.getBoundingClientRect();
            if (itemRect.width > 0) {
              const itemCenter = itemRect.left + itemRect.width / 2;
              const distance = Math.abs(itemCenter - containerCenter);
              
              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            }
          });
          
          return closestIndex;
        };
        
        const updateActiveDot = () => {
          const activeIndex = getActiveMediaIndex();
          if (activeIndex >= 0) {
            self.updateActiveDot(activeIndex, mediaCount, dots, dotTargets);
          }
        };

        galleryViewer.addEventListener('slideChanged', (event) => {
          if (event.detail && event.detail.currentElement) {
            const activeMedia = event.detail.currentElement;
            const activeIndex = Array.from(mediaItems).indexOf(activeMedia);
            if (activeIndex >= 0) {
              self.updateActiveDot(activeIndex, mediaCount, dots, dotTargets);
            }
          } else {
            setTimeout(updateActiveDot, 100);
          }
        });
        
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const target = mutation.target;
              if (target.classList.contains('product__media-item')) {
                if (target.classList.contains('is-active')) {
                  const activeIndex = Array.from(mediaItems).indexOf(target);
                  if (activeIndex >= 0) {
                    self.updateActiveDot(activeIndex, mediaCount, dots, dotTargets);
                  }
                }
              }
            }
          });
        });
        
        mediaItems.forEach((item) => {
          observer.observe(item, {
            attributes: true,
            attributeFilter: ['class']
          });
        });
        
        let scrollTimeout;
        mediaList.addEventListener('scroll', () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(updateActiveDot, 150);
        });
        
        setTimeout(updateActiveDot, 300);
      }

      navigateToMedia(targetIndex, mediaList, dots) {
        const mediaItems = mediaList.querySelectorAll('.product__media-item');
        if (targetIndex < 0 || targetIndex >= mediaItems.length) return;

        const targetMedia = mediaItems[targetIndex];
        if (!targetMedia) return;

        const mediaId = targetMedia.getAttribute('data-media-id');
        
        const mediaGallery = this.modalContent.querySelector('media-gallery');
        if (mediaGallery && mediaGallery.setActiveMedia && mediaId) {
          mediaGallery.setActiveMedia(mediaId, false);
          
          setTimeout(() => {
            const mediaCount = mediaItems.length;
            const dotTargets = [
              0,
              mediaCount === 2 ? 1 : Math.floor((1 + (mediaCount - 2)) / 2),
              mediaCount - 1
            ];
            this.updateActiveDot(targetIndex, mediaCount, dots, dotTargets);
          }, 200);
        } else {
          mediaItems.forEach(item => item.classList.remove('is-active'));
          targetMedia.classList.add('is-active');
          
          targetMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          
          const mediaCount = mediaItems.length;
          const dotTargets = [
            0,
            mediaCount === 2 ? 1 : Math.floor((1 + (mediaCount - 2)) / 2),
            mediaCount - 1
          ];
          this.updateActiveDot(targetIndex, mediaCount, dots, dotTargets);
        }
      }

      updateActiveDot(currentIndex, mediaCount, dots, dotTargets) {
        if (!dots || dots.length !== 3) return;
        
        let activeDotIndex = 0;

        if (currentIndex === 0) {
          activeDotIndex = 0;
        } else if (currentIndex === mediaCount - 1) {
          activeDotIndex = 2;
        } else if (currentIndex > 0 && currentIndex < mediaCount - 1) {
          activeDotIndex = 1;
        }

        dots.forEach((dot, index) => {
          const isActive = index === activeDotIndex;
          if (isActive) {
            dot.classList.add('slider-counter__link--active');
            dot.setAttribute('aria-selected', 'true');
          } else {
            dot.classList.remove('slider-counter__link--active');
            dot.setAttribute('aria-selected', 'false');
          }
        });
      }

      initMediaFiltering() {
        const modalContent = this.modalContent;
        if (!modalContent) return;

        if (this._mediaFilteringInitialized) return;
        this._mediaFilteringInitialized = true;

        const getColorValueFromAlt = (altText) => {
          if (!altText) return '';
          const altLower = altText.toLowerCase();
          if (altLower.includes('pink')) return 'PG';
          if (altLower.includes('white')) return 'WG';
          if (altLower.includes('yellow')) return 'YG';
          return '';
        };

        const getVariantSKU = () => {
          const variantSelects = modalContent.querySelector('variant-selects');
          if (!variantSelects) return '';

          const selectedVariantData = variantSelects.querySelector('[data-selected-variant]');
          if (selectedVariantData) {
            try {
              const variantData = JSON.parse(selectedVariantData.textContent);
              return variantData.sku || '';
            } catch (e) {
              // Ignore parse errors
            }
          }
          return '';
        };

        const filterMediaByMetalOption = (metalValue, variantSKU) => {
          if (!metalValue) return;

          const mediaLists = modalContent.querySelectorAll('.product__media-list');
          if (mediaLists.length === 0) return;

          mediaLists.forEach((mediaList) => {
            const mediaItems = mediaList.querySelectorAll('.product__media-item');
            const mediaGallery = mediaList.closest('media-gallery');
            const thumbnailList = mediaGallery
              ? mediaGallery.querySelector('.thumbnail-list')
              : modalContent.querySelector('.thumbnail-list');
            
            if (!thumbnailList) return;

            const thumbnailItems = Array.from(thumbnailList.querySelectorAll('.thumbnail-list__item'));

            let firstMatchingMedia = null;
            let firstMatchingThumbnail = null;

            // Clear all active states
            mediaItems.forEach((mediaItem) => {
              mediaItem.classList.remove('is-active');
            });

            thumbnailItems.forEach((thumbItem) => {
              thumbItem.classList.remove('is-active');
              const thumbButton = thumbItem.querySelector('button');
              if (thumbButton) {
                thumbButton.setAttribute('aria-current', 'false');
              }
            });

            // Filter media items
            mediaItems.forEach((mediaItem) => {
              const mediaColorValue = mediaItem.dataset.colorValue || '';
              let mediaSKU = mediaItem.dataset.mediaSku || '';
              const mediaId = mediaItem.dataset.mediaId;

              if (!mediaSKU) {
                const mediaAlt = mediaItem.dataset.mediaAlt || '';
                if (mediaAlt) {
                  const skuMatch =
                    mediaAlt.match(/\bSKU[\s-:]*([A-Z0-9-]+)\b/i) || mediaAlt.match(/\b([A-Z]{2,}[0-9-]+)\b/);
                  if (skuMatch) {
                    mediaSKU = skuMatch[1] || skuMatch[0];
                  }
                }
              }

              let shouldShow = false;

              if (variantSKU && mediaSKU) {
                shouldShow = mediaSKU === variantSKU && mediaColorValue === metalValue;
              } else {
                shouldShow = mediaColorValue === metalValue;
              }

              if (shouldShow) {
                mediaItem.style.removeProperty('display');
                if (!firstMatchingMedia) {
                  firstMatchingMedia = mediaItem;
                }
              } else {
                mediaItem.style.display = 'none';
              }
            });

            // Filter thumbnails - FIXED TO HANDLE ID MISMATCHES
            thumbnailItems.forEach((thumbItem) => {
              const thumbImg = thumbItem.querySelector('img');
              if (!thumbImg) {
                thumbItem.style.display = 'none';
                return;
              }

              const thumbAlt = thumbImg.getAttribute('alt') || '';
              const thumbColorValue = getColorValueFromAlt(thumbAlt);
              const thumbTarget = thumbItem.dataset.target;

              // CRITICAL FIX: Find media by matching alt text, not just by ID
              // This handles cases where IDs change between variants
              let correspondingMedia = Array.from(mediaItems).find((item) => item.dataset.mediaId === thumbTarget);
              
              // If ID doesn't match, try matching by image alt text
              if (!correspondingMedia) {
                correspondingMedia = Array.from(mediaItems).find((item) => {
                  const itemAlt = item.dataset.mediaAlt || '';
                  return itemAlt === thumbAlt;
                });
              }
              
              let thumbSKU = '';
              if (correspondingMedia) {
                thumbSKU = correspondingMedia.dataset.mediaSku || '';
                if (!thumbSKU) {
                  const mediaAlt = correspondingMedia.dataset.mediaAlt || '';
                  if (mediaAlt) {
                    const skuMatch =
                      mediaAlt.match(/\bSKU[\s-:]*([A-Z0-9-]+)\b/i) || mediaAlt.match(/\b([A-Z]{2,}[0-9-]+)\b/);
                    if (skuMatch) {
                      thumbSKU = skuMatch[1] || skuMatch[0];
                    }
                  }
                }
              }

              let shouldShowThumb = false;
              if (variantSKU && thumbSKU) {
                shouldShowThumb = thumbSKU === variantSKU && thumbColorValue === metalValue;
              } else {
                shouldShowThumb = thumbColorValue === metalValue;
              }

              if (shouldShowThumb) {
                thumbItem.style.removeProperty('display');
                thumbItem.style.removeProperty('visibility');
                thumbItem.classList.remove('hide', 'thumbnail-filtered-hidden');
                if (!firstMatchingThumbnail) {
                  firstMatchingThumbnail = thumbItem;
                }
              } else {
                thumbItem.style.display = 'none';
                thumbItem.style.visibility = 'hidden';
                thumbItem.classList.add('hide', 'thumbnail-filtered-hidden');
              }
            });

            // Set active state
            if (firstMatchingMedia && firstMatchingThumbnail) {
              firstMatchingMedia.classList.add('is-active');
              firstMatchingThumbnail.classList.add('is-active');
              const thumbButton = firstMatchingThumbnail.querySelector('button');
              if (thumbButton) {
                thumbButton.setAttribute('aria-current', 'true');
              }

              if (mediaGallery && typeof mediaGallery.updateActiveMedia === 'function') {
                mediaGallery.updateActiveMedia(firstMatchingMedia);
              }
            } else if (mediaItems.length > 0) {
              // Fallback
              mediaItems[0].style.removeProperty('display');
              mediaItems[0].classList.add('is-active');
              
              const firstMediaAlt = mediaItems[0].dataset.mediaAlt || '';
              const firstThumb = thumbnailItems.find(t => {
                const thumbImg = t.querySelector('img');
                return thumbImg && thumbImg.getAttribute('alt') === firstMediaAlt;
              });
              
              if (firstThumb) {
                firstThumb.style.removeProperty('display');
                firstThumb.style.removeProperty('visibility');
                firstThumb.classList.remove('hide', 'thumbnail-filtered-hidden');
                firstThumb.classList.add('is-active');
                const thumbButton = firstThumb.querySelector('button');
                if (thumbButton) {
                  thumbButton.setAttribute('aria-current', 'true');
                }
              }
            }
          });
        };

        const getMetalColourValue = () => {
          const variantSelects = modalContent.querySelector('variant-selects');
          if (!variantSelects) return null;

          const containers = variantSelects.querySelectorAll('fieldset, .product-form__input--dropdown');
          for (const container of containers) {
            const formLabel = container.querySelector('.form__label[form__label_name="Metal Colour"]');
            if (formLabel) {
              const checkedRadio = container.querySelector('input[type="radio"]:checked');
              if (checkedRadio) {
                const value = checkedRadio.value.trim();
                if (value === 'PG' || value === 'WG' || value === 'YG') {
                  return value;
                }
              }

              const select = container.querySelector('select');
              if (select) {
                const selectedOption = select.options[select.selectedIndex];
                if (selectedOption) {
                  const value = selectedOption.value.trim();
                  if (value === 'PG' || value === 'WG' || value === 'YG') {
                    return value;
                  }
                }
              }

              const checkedSwatch = container.querySelector('.swatch-input__input:checked');
              if (checkedSwatch) {
                const swatchLabel = checkedSwatch.nextElementSibling;
                if (swatchLabel) {
                  const value =
                    swatchLabel.getAttribute('title') || swatchLabel.dataset.metalValue || checkedSwatch.value || '';
                  const trimmedValue = value.trim();
                  if (trimmedValue === 'PG' || trimmedValue === 'WG' || trimmedValue === 'YG') {
                    return trimmedValue;
                  }
                }
              }
            }
          }
          return null;
        };

        const initializeMediaFilter = () => {
          const metalValue = getMetalColourValue();
          if (metalValue) {
            const variantSKU = getVariantSKU();
            filterMediaByMetalOption(metalValue, variantSKU);
          }
        };

        let changeTimeout;
        const handleChange = (event) => {
          const input = event.target;
          const container = input.closest('fieldset, .product-form__input--dropdown');
          if (container) {
            const formLabel = container.querySelector('.form__label[form__label_name="Metal Colour"]');
            if (formLabel && modalContent.contains(input)) {
              clearTimeout(changeTimeout);
              changeTimeout = setTimeout(() => {
                const metalValue = getMetalColourValue();
                if (metalValue) {
                  const variantSKU = getVariantSKU();
                  filterMediaByMetalOption(metalValue, variantSKU);
                }
              }, 50);
            }
          }
        };

        modalContent.addEventListener('change', handleChange);

        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          const variantChangeHandler = (event) => {
            if (event.data && event.data.variant) {
              if (this.hasAttribute('open') && modalContent.querySelector('variant-selects')) {
                setTimeout(() => {
                  initializeMediaFilter();
                }, 100);
              }
            }
          };
          subscribe(PUB_SUB_EVENTS.variantChange, variantChangeHandler);
          this._variantChangeHandlers = this._variantChangeHandlers || [];
          this._variantChangeHandlers.push(variantChangeHandler);
        }

        setTimeout(() => {
          initializeMediaFilter();
        }, 200);
      }

      initThumbnailActiveSync() {
        const modalContent = this.modalContent;
        if (!modalContent) return;

        const mediaList = modalContent.querySelector('.product__media-list');
        const thumbnailList = modalContent.querySelector('.thumbnail-list');
        
        if (!mediaList || !thumbnailList) return;

        // ===== CORE FUNCTION: Handle thumbnail click =====
        const handleThumbnailClick = (clickedThumbnailItem) => {
          const allMediaItems = mediaList.querySelectorAll('.product__media-item');
          const allThumbnailItems = thumbnailList.querySelectorAll('.thumbnail-list__item');

          // Remove active from all
          allMediaItems.forEach(item => item.classList.remove('is-active'));
          allThumbnailItems.forEach(item => {
            item.classList.remove('is-active');
            const btn = item.querySelector('button');
            if (btn) btn.setAttribute('aria-current', 'false');
          });

          // Get thumbnail target ID
          const targetMediaId = clickedThumbnailItem.dataset.target;
          if (!targetMediaId) return;

          // Find target media item - CRITICAL FIX: Use alt text as fallback
          let targetMediaItem = mediaList.querySelector(`[data-media-id="${targetMediaId}"]`);
          
          // If not found by ID, try matching by image alt text
          if (!targetMediaItem) {
            const thumbImg = clickedThumbnailItem.querySelector('img');
            if (thumbImg) {
              const thumbAlt = thumbImg.getAttribute('alt');
              targetMediaItem = Array.from(allMediaItems).find(item => {
                return item.dataset.mediaAlt === thumbAlt;
              });
            }
          }

          if (targetMediaItem && targetMediaItem.style.display !== 'none') {
            targetMediaItem.classList.add('is-active');
          }

          clickedThumbnailItem.classList.add('is-active');
          const clickedBtn = clickedThumbnailItem.querySelector('button');
          if (clickedBtn) {
            clickedBtn.setAttribute('aria-current', 'true');
          }

          // Scroll media into view
          if (targetMediaItem) {
            setTimeout(() => {
              if (targetMediaItem.style.display !== 'none') {
                if (mediaList.scrollTo) {
                  const scrollLeft = targetMediaItem.offsetLeft - (mediaList.clientWidth / 2) + (targetMediaItem.offsetWidth / 2);
                  mediaList.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                  });
                } else {
                  targetMediaItem.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                  });
                }
              }
            }, 50);
          }

          // Notify media-gallery
          const mediaGallery = modalContent.querySelector('media-gallery');
          if (mediaGallery && targetMediaItem && typeof mediaGallery.setActiveMedia === 'function') {
            const mediaId = targetMediaItem.getAttribute('data-media-id');
            if (mediaId) {
              mediaGallery.setActiveMedia(mediaId, false);
            }
          }
        };

        // ===== ATTACH CLICK HANDLERS =====
        const attachClickHandlers = () => {
          const allThumbnailItems = thumbnailList.querySelectorAll('.thumbnail-list__item');
          
          allThumbnailItems.forEach((thumbnailItem) => {
            const btn = thumbnailItem.querySelector('button');
            
            if (btn && !btn.hasAttribute('data-click-handler-attached')) {
              btn.setAttribute('data-click-handler-attached', 'true');
              
              btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                // Check if visible
                if (thumbnailItem.style.display === 'none' || thumbnailItem.style.visibility === 'hidden') {
                  return;
                }
                
                // Handle click
                handleThumbnailClick(thumbnailItem);
              });
            }
          });
        };

        // Initial setup
        attachClickHandlers();
        
        // Re-attach after DOM updates
        const resizeObserver = new ResizeObserver(() => {
          attachClickHandlers();
        });
        resizeObserver.observe(modalContent);
      }
    }
  );
}